import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DiscountBadge } from '@shared/components/display/DiscountBadge/DiscountBadge';
import type { SubItemPromo } from '@t/api.types';

type DiscountInfoProps = {
  promo?: SubItemPromo | null;
  discountTag?: string;
  discountMessage?: string;
  layout?: 'stacked' | 'inline';
};

export const DiscountInfo = ({
  promo,
  discountTag,
  discountMessage,
  layout = 'stacked',
}: DiscountInfoProps): React.JSX.Element | null => {
  const tag = discountTag ?? promo?.tag;
  const message = discountMessage ?? promo?.savingsMessage;

  if (!tag && !message) return null;

  if (layout === 'inline') {
    return (
      <Stack direction="row" alignItems="center" spacing={1} useFlexGap mt="4px">
        {tag && (
          <DiscountBadge>
            <Typography variant="discount.tag" noWrap>
              {tag}
            </Typography>
          </DiscountBadge>
        )}
        {message && (
          <>
            <Typography component="p" variant="discount.text">
              {message}
            </Typography>
            <Typography component="p" variant="discount.text">
              Discount applied at checkout
            </Typography>
          </>
        )}
      </Stack>
    );
  }

  return (
    <Stack alignItems={{ xs: 'flex-start', md: 'flex-end' }} gap="4px" mt="4px">
      {tag && (
        <Box alignSelf={{ xs: 'flex-start', md: 'flex-end' }}>
          <DiscountBadge>
            <Typography variant="discount.tag" noWrap>
              {tag}
            </Typography>
          </DiscountBadge>
        </Box>
      )}
      {message && (
        <>
          <Typography component="p" variant="discount.text" whiteSpace="nowrap">
            {message}
          </Typography>
          <Typography component="p" variant="discount.text" whiteSpace="nowrap">
            Discount applied at checkout
          </Typography>
        </>
      )}
    </Stack>
  );
};
